import TooltipV3 from './Tooltip.v3'

export default TooltipV3
// eslint-disable-next-line import/export
export * from './Tooltip.v3'
